import React from 'react';
import { HdIcon } from '../../../../components';

export function ObjectExplorerFieldsEmpty() {
  return (
    <div className='no-item-box'>
      <div className='no-item-box-icon-container'>
        <HdIcon name='table' className='no-item-box-icon'/>
      </div>

      <p className='no-item-box-title'>
        No Target Fields found 😔
      </p>
    </div>
  );
}
